export type CTraderConnectionParameters = {
    host: string;
    port: number;
};
